export const _url = {
  server: 'https://data.topjob360.com/',
  urlViewPage: "http://topjob360.com/",
  //server: 'https://worldjobs20231122155823.azurewebsites.net/',
  //server: 'https://icy-plant-0a08d5600.4.azurestaticapps.net/',

  apiLogin: 'Account/login',
  apiRegister: 'Account/register',
  apiRefreshToken: 'Account/refresh',
  apiForgotPassword: 'Account/forgotPassword',
  apiChangePassword: 'Account/changepassword',
  apiUpdateProfile: 'Account/updatecv',
  apiUpdateAvatar: 'Account/updateAvatar',
  apiUpdateImage: 'Account/updateImage',
  apiGetAccountInfo: 'Account/me',
  apiGetUserInfo: 'Account/u',
  apiConfirmEmail: 'Account/confirmEmail',
  apiChangeUserName: 'Account/changeusername',
  apiViewCompany: 'Account/company',
  apiGetAllCompany: 'Account/companies',
  apiUpdateFile: 'Account/updateFile',
  apiGetMyFile: 'Account/myFile',
  apiDownloadFile: 'Account/download',
  apiGetUsers: 'Account/users',
  apiDeleteUser: 'Account/delete',
  apiConfirmPhoneNumber: 'Account/activephone',

  apiGetListCities: 'Country/ListCities',
  apiMaster: 'Master/Get',

  apiUpdateCompany: 'Account/updatecompany',
  apiStatusUser: 'Account/updatestatus',
  apiFeatureUser: 'Account/featured',

  apiCreateJob: 'Jobs/create',
  apiUpdateJob: 'Jobs/update',
  apiGetListJob: 'Jobs/getList',
  apiGetListJobAll: 'Jobs/all',
  apiGetMyJob: 'Jobs/myJobs',
  apiGetMyApplied: 'Jobs/Myapplied',
  apiJobByUser: 'Jobs/getListByUser',
  apiDeleteJob: 'Jobs/delete',
  apiFeaturedJob: 'Jobs/featured',
  apiActive: 'Jobs/active',
  apiDeactive: 'Jobs/deactive',
  apiApplyJob: 'Jobs/apply',
  apiGetListJobHome: 'Jobs/home',
  apiApplyJobList: 'Jobs/applies',
  apiJobDownloadFile: 'Jobs/downloadFile',
  //category
  apiCreateCategory: 'Categories/create',
  apiUpdateCategory: 'Categories/update',
  apiGetCategory: 'Categories/',
  apiDeleteCategory: 'Categories/delete',

  //visa
  apiGetVisa: 'Country/Visas',
  apiVisaMod: 'Country/Visa/Mod',

  //country/city
  apiCountryList: 'Country/List',
  apiCountryMod: 'Country/Mod',
  apiCityList: 'Country/ListCities',
  apiCityMod: 'Country/City/Mod',

  //language
  apiGetLanguage: 'Country/Languages',
  apiLanguageMod: 'Country/Language/Mod',

  //blog
  apiListBlog : 'Blog/list',
  apiCreateBlog : 'Blog/create',
  apiDeleteBlog: 'Blog/delete',
  apiGetBlogCat: 'Blog/categories',
  apiUploadImage: 'Blog/upload',
  apiGetAllImage: 'Blog/allimage'
}

export const siteKey = "6LcpjyAqAAAAAIobc52-XkoDhjwKbECm4GJuempX";
// Set time out for API Server
const timeOutNumber = 60;

export const timeout = (promise) => {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error("timeout"))
    }, timeOutNumber * 1000)
    promise.then(resolve, reject)
  })
}
